'use strict';
'use es6';
// pubnub time tokens are in 10^7 precision, but we want milliseconds

Object.defineProperty(exports, "__esModule", {
  value: true
});
var PUBNUB_CONVERSION = 10000;

var getTimestampFromToken = exports.getTimestampFromToken = function getTimestampFromToken(timeToken) {
  return Math.floor(timeToken / PUBNUB_CONVERSION);
};


//////////////////
// WEBPACK FOOTER
// ./js/pubnub/utils/getTimestampFromToken.js
// module id = 627
// module chunks = 2 3